import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {

  1: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P27-E1',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page27/E1/Key/answerKey.png',
    component: D1,
    textAlign: 'center',
    maxLength: 2,
    isAllowSubmit: false,
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page27/E1/1.jpg' },

      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page27/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page27/E1/3.jpg', input: true, answer: "37" },
        { url: 'img/FriendsPlus/Page27/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page27/E1/5.jpg', input: true, answer: "46" },
        { url: 'img/FriendsPlus/Page27/E1/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page27/E1/7.jpg' },

      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page27/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page27/E1/9.jpg', input: true, answer: "79" },
        { url: 'img/FriendsPlus/Page27/E1/10.jpg' },

      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page27/E1/11.jpg' },

      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page27/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page27/E1/13.jpg', input: true, answer: "81" },
        { url: 'img/FriendsPlus/Page27/E1/14.jpg' },

      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page27/E1/15.jpg' },

      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page27/E1/16.jpg' },

      ],

    ]
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P27-E2',
    audio: '',
    video: '',
    component: T6,
    exerciseKey: 'img/FriendsPlus/Page27/E2/Key/answerKey.png',
    inputSize: 200,
    checkUppercase: true,
    // titleImage: 'img/FriendsPlus/Page21/E1/title.jpg',
    titleQuestion: [{ num: '4', title: 'Complete the question.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title:
          `
          <div style='line-height: 58px;display:flex;width:900px;justify-content: space-between;'>
            <div>
              <div><b>1</b> <u style='color: gray;'><i> Do you have</i></u> a milkshake? Yes, I do.</div>
              <div><b>2</b> # a sandwich? Yes, he does</div>
              <div><b>3</b> # noodles? No, I don't.</div>
              <div><b>4</b> # a pizza? No, she doesn't</div> 
            </div>
            <div>
             <img src="img/FriendsPlus/Page27/E2/1.jpg" style="width: 110%" />
            </div>
          </div>
          `,
        answer: [
          "Does he have",
          "Do you like",
          "Does she have",
        ],
      },
    ]
  },
  3: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P27-E2',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 5,
    exerciseKey: 'img/FriendsPlus/Page27/E3/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page27/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page27/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page27/E3/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page27/E3/4.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page27/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page27/E3/6.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page27/E3/7.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page27/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page27/E3/9.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page27/E3/10.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page27/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page27/E3/12.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page27/E3/13.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page27/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page27/E3/15.jpg', input: 5, isCorrect: true },
        { url: 'img/FriendsPlus/Page27/E3/16.jpg', input: 5, },
        { url: 'img/FriendsPlus/Page27/E3/17.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page27/E3/18.jpg' },
      ],


    ]
  },

}

export default json;